class SwiperElement extends HTMLElement {
  swiper; options;

  constructor(){
    super();
    this.init();
  } 

  init = () => {
    this.options = {
      margin: 0
    };
    if(this.dataset.breakpoints != undefined){
      this.options.breakpoints = this.options.breakpoints || {};
      const points = this.dataset.breakpoints.split(';');
      points.forEach((point) => {
        const bp = point.split(':');
        this.options.breakpoints[bp[0]] = {
          slidesPerView: bp[1]
        }
      });
    }
    if(this.dataset.xlDirection != undefined){
      this.options.breakpoints = this.options.breakpoints || {};
      this.options.breakpoints[1200] = {
        direction: this.dataset.xlDirection
      }
    }
    if(this.dataset.direction != undefined){
      this.options.direction = this.dataset.direction;
    }
    if(this.dataset.margin != undefined){
      this.options.margin = this.dataset.margin;
    }
    if(this.dataset.loop != undefined){
      this.options.loop = true;
    }
    if(this.dataset.navigation != undefined){
      this.options.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      };
    }
    if(this.dataset.number != undefined){
      this.options.pagination = {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className}"><span class="index">${(index+1)}</span><span class="px-4">/</span></span>`;
        },
      };
    }
    if(this.dataset.autoplay != undefined){
      this.options.autoplay = {
        delay: parseInt(this.dataset.autoplay) <= 0 ? 2500 : parseInt(this.dataset.autoplay),
        disableOnInteraction: false
      };
    }
    if(this.dataset.touch == 'false'){
      this.options.allowTouchMove = false;
    }
    if(this.dataset.autowidth != undefined){
      this.options.slidesPerView = 'auto';
    } else if(this.dataset.slides != undefined){
      this.options.slidesPerView = this.dataset.slides;
    }
    this.swiper = new Swiper(this, this.options);
    if(parseInt(this.dataset.start) > 0){
      this.swiper.slideTo(parseInt(this.dataset.start), 0);
    }
  }
}
if (!window.customElements.get("swiper-element")) {
  window.customElements.define("swiper-element", SwiperElement);
}